import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {HttpErrorResponse} from '@angular/common/http';
import {DataService} from '../../../../Services/data.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {AppConfigService} from '../../../../Services/app-config.service';

@Component({
  selector: 'app-bank-import-history',
  templateUrl: './bank-import-history.component.html',
  styleUrls: ['./bank-import-history.component.css'],
  standalone: false
})
export class BankImportHistoryComponent implements OnInit {

  vm: any = {
    list: [],
    banks: [],
    bank_id: '',
    company_id: '',
    detail: null,
    reversing: false,
    reverseConfirmImportId: null,
  };

  page = 1;
  pageSize = 25;
  startIndex = 1;
  endIndex = 0;
  totalRecords = 0;
  pageSizeOptions: number[] = [10, 25, 50];
  isLoaded = false;

  private get apiBase(): string {
    return this.appConfig.apiBaseUrl;
  }

  constructor(
    private router: Router,
    private titleService: Title,
    private tableDataService: DataService,
    private notification: BsToastService,
    private appConfig: AppConfigService,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('Bank Import History');
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || history.state;
    if (state?.bank_id) {
      this.vm.bank_id = state.bank_id;
    }
    if (state?.company_id) {
      this.vm.company_id = state.company_id;
    }
    this.loadBanks();
    this.getData();
  }

  loadBanks() {
    this.tableDataService.getApiListData('bank', '?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: any) => {
        this.vm.banks = result.Data || [];
      },
      error: () => {
      }
    });
  }

  getData() {
    this.isLoaded = false;
    let params = `pageNumber=${this.page - 1}&pageSize=${this.pageSize}`;
    if (this.vm.bank_id) {
      params += `&bank_id=${this.vm.bank_id}`;
    }
    if (this.vm.company_id) {
      params += `&company_id=${this.vm.company_id}`;
    }
    console.log('[BankImportHistory][getData] url:', this.apiBase + 'bank-import?' + params, 'params:', {
      bank_id: this.vm.bank_id,
      company_id: this.vm.company_id,
      page: this.page - 1,
      pageSize: this.pageSize
    });
    this.tableDataService.getApiListData('bank-import', '?' + params).subscribe({
      next: (result: any) => {
        console.log('[BankImportHistory][getData] result:', result);
        this.vm.list = result.data || result.Data || [];
        this.totalRecords = result.totalRecords || 0;
        this.paginate(false);
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  paginate(withFetch: boolean) {
    if (this.totalRecords === 0) {
      this.startIndex = 0;
      this.endIndex = 0;
      return;
    }
    this.startIndex = (this.page - 1) * this.pageSize + 1;
    this.endIndex = Math.min(this.page * this.pageSize, this.totalRecords);
    if (withFetch) {
      this.getData();
    }
  }

  viewDetail(importId: string) {
    this.vm.detail = null;
    this.tableDataService.getData('bank-import', importId).subscribe({
      next: (result: any) => {
        this.vm.detail = result;
      },
      error: () => {
        this.notification.showErrorToast('Failed to load import detail.');
      }
    });
  }

  closeDetail() {
    this.vm.detail = null;
    this.vm.reverseConfirmImportId = null;
  }

  promptReverse(importId: string) {
    this.vm.reverseConfirmImportId = importId;
  }

  cancelReverse() {
    this.vm.reverseConfirmImportId = null;
  }

  reverseImport(importId: string) {
    this.vm.reversing = true;
    this.tableDataService.post(`bank-import/${importId}/reverse`, {}).subscribe({
      next: () => {
        this.vm.reversing = false;
        this.vm.reverseConfirmImportId = null;
        this.vm.detail = null;
        this.notification.showSuccessToast('Import reversed successfully.');
        this.getData();
      },
      error: (err: HttpErrorResponse) => {
        this.vm.reversing = false;
        this.notification.showErrorToast(err.error?.message || 'Reversal failed.');
      }
    });
  }

  onBankChange() {
    const bank = this.vm.banks.find((b: any) => b.id === this.vm.bank_id);
    this.vm.company_id = bank ? (bank.company_id || '') : '';
    this.page = 1;
    this.getData();
  }

  goToWizard() {
    this.router.navigate(['/transactions/bank-import/wizard']).then();
  }

  resumeImport(row: any) {
    this.router.navigate(['/transactions/bank-import/wizard'], {
      queryParams: {
        import_id: row.import_id,
        bank_id: row.bank_id || ''
      }
    }).then();
  }

  statusBadgeClass(status: string): string {
    switch (status) {
      case 'confirmed':
        return 'fpt-badge-success';
      case 'completed':
        return 'fpt-badge-success';
      case 'in_progress':
        return 'fpt-badge-warning';
      case 'pending':
        return 'fpt-badge-warning';
      case 'reversed':
        return 'badge bg-danger text-white';
      default:
        return 'badge bg-light';
    }
  }

  itemStatusBadgeClass(status: string): string {
    switch (status) {
      case 'matched':
        return 'fpt-badge-success';
      case 'unmatched':
        return 'fpt-badge-warning';
      case 'duplicate':
        return 'badge bg-secondary';
      case 'ignored':
        return 'badge bg-light text-muted';
      case 'posted':
        return 'fpt-badge-success';
      case 'skipped':
        return 'badge bg-secondary';
      default:
        return 'badge bg-light';
    }
  }

  amountClass(amount: number): string {
    return amount < 0 ? 'text-danger' : 'text-success';
  }
}
